import React from 'react';
import { connectDeep } from 'redux-utils';

import { savePermissions } from 'actions/gallery';
import {
  connect as connectPermissions
} from '../../Permission/index';
import { ModalProps } from '../types';
import Dialog from '../../Dialog/index';
import Typography from '../../Typography';

import i18n from 'i18n';
import PermissionsEditor from '../../Permission/PermissionsEditor';
import { GalleryAppPermissions } from '../../Permission/types';

const mapDispatchToProps = (dispatch: any, { app }: any) => ({
  savePermissions: (grantedPermissions: any) =>
    dispatch(savePermissions({ appId: app.id, grantedPermissions }))
});

type ReduxProps = ReturnType<typeof mapDispatchToProps>;

interface ConnectedPermissionsProps {
  permissions: GalleryAppPermissions;
}

interface PermissionModalProps extends ModalProps, ConnectedPermissionsProps, ReduxProps {}

class PermissionModal extends React.Component<PermissionModalProps> {
  componentDidMount() {
    const {
      permissions,
      savePermissions,
    } = this.props;

    savePermissions(permissions);
  }

  render() {
    const {
      app,
      onSuccess,
      onCancel,
      savePermissions,
    } = this.props;
  
    const onPermissionsChange =
      async (grantedPermissions: any) => savePermissions(grantedPermissions);

    return (
      <Dialog
        show={true}
        id="PermissionModal"
        title={i18n('component.PermissionModal.title')({ appName: app.name })}
        onDismiss={onCancel}
        actions={[
          {
            text: i18n('component.PermissionModal.disallowButtonText')(),
            onClick: onCancel,
            variant: 'text',
            id: 'permissions-button-cancel',
          },
          {
            text: i18n('component.PermissionModal.allowButtonText')(),
            onClick: onSuccess,
            variant: 'filled',
            id: 'permissions-button-ok',
          }
        ]}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <Typography variant="bodyMedium" color="var(--sys-color--on-surface-variant)">
            {i18n('component.PermissionModal.text')()}
          </Typography>
          <PermissionsEditor app={app} onChange={onPermissionsChange} />
        </div>
      </Dialog>
    );
  }
}

export default connectPermissions(
  connectDeep(null, mapDispatchToProps)(PermissionModal)
);
